angular.module("admin").factory("AdminConsumersService", ["$rootScope", "$http", "ENV", function ($rootScope, $http, ENV) {

	const TEMPLATES_URL = ENV.API_URL + "/admin/consumers";
	const vm = {
		get: (id) => $http.get(TEMPLATES_URL + "/" + id),
		getAll: () => $http.get(TEMPLATES_URL),
		save: (entity) => !entity.id ? vm.add(entity) : vm.update(entity),
		add: (consumer) => $http.post(TEMPLATES_URL, consumer),
		update: (consumer) => $http.put(TEMPLATES_URL + "/" + consumer.id, consumer),
		delete: (id) => $http.delete(TEMPLATES_URL + "/" + id),
		updateOpendatasoftInfos: (exportDate, description) => $http.post(TEMPLATES_URL + "/updateOpendataSoftInfos",{}
		, {
			headers: {"exportDate": exportDate, "description" : description}
		})
	};

	return vm;
}]);